module.exports = __webpack_public_path__ + "img/13.24702c92.png";